import React from 'react';
import '../assets/navigation.scss';
import navigation_icon from 'src/images/icon/navigation_icon.png';
import {
    AAC_REGISTER,
    CONTRACTS,
    DEALERSHIP_INFORMATION,
    HOME_LOCATION_PATH,
    OVERVIEW,
    STEP_STATE
} from "src/constants/Steps";

interface NavigationProps {
    currentStep: string;
    onStepChange?: (step: number) => void;
    onFAQClick?: () => void;
    onContactUsClick?: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentStep, onStepChange, onFAQClick, onContactUsClick }) => {
    const ENABLE_NAVIGATION = false // Set to true to enable navigation between steps for local testing
    const steps = [
        { id: OVERVIEW, label: 'Overview' }
    ];

    const handleStepClick = (stepId: string) => {
        if (onStepChange) {
            onStepChange(STEP_STATE[stepId]);
        } else {
            switch (stepId) {
                case OVERVIEW:
                    window.location.href = HOME_LOCATION_PATH;
                    break;
                case DEALERSHIP_INFORMATION:
                    document.getElementById(DEALERSHIP_INFORMATION)?.scrollIntoView({ behavior: 'smooth' });
                    break;
                case CONTRACTS:
                    document.getElementById(CONTRACTS)?.scrollIntoView({ behavior: 'smooth' });
                    break;
                case AAC_REGISTER:
                    document.getElementById(AAC_REGISTER)?.scrollIntoView({ behavior: 'smooth' });
                    break;
            }
        }
    };

    const handleFaqClick = () => {
        if (onFAQClick) {
            onFAQClick();
        }
    };

    const handleContactUsClick = () => {
        if (onContactUsClick) {
            onContactUsClick();
        }
    };

    return (
        <div className="navigation">
            <div className="navigation-header">
                <div className="navigation-title">Preregistration Hub</div>
            </div>
            
            <div className="steps-section">
                <div className="steps-title">Steps to complete</div>
                <div className="steps-list">
                    {steps.map(step => (
                        <div 
                            key={step.id} 
                            className={`step-box ${currentStep === step.id ? 'active' : ''} ${!ENABLE_NAVIGATION && currentStep !== step.id ? 'disabled' : ''}`}
                            onClick={ENABLE_NAVIGATION ? () => handleStepClick(step.id) : undefined}
                            role="button"
                            tabIndex={0}
                            aria-selected={currentStep === step.id}
                            style={!ENABLE_NAVIGATION && currentStep !== step.id ? { cursor: 'not-allowed', opacity: 0.6 } : undefined}
                        >
                            <div className="navigation-step-content">
                                <span className="step-text">{step.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="faq-section">
                <div 
                    className="faq-box"
                    onClick={handleFaqClick}
                    // role="button"
                    tabIndex={0}
                >
                    <span className="step-text">Get help</span>
                    <img src={navigation_icon} alt="" className="step-arrow" />
                </div>
            </div>

            <div className="help-section">
                <div className="help-box">
                    <a className="help-email" href="mailto:autosdealerbd-salesops@amazon.com">autosdealerbd-salesops@amazon.com</a>
                </div>
                <div className="contact-box" onClick={handleContactUsClick}>
                    <span className="step-text">Contact us</span>
                    <img src={navigation_icon} alt="" className="step-arrow" />
                </div>
            </div>
        </div>
    );
};

export default Navigation;
